import React from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import LGModalCrud from "../../organisms/LGCrud/LGModalCrud";
import QCReportForm from "../../organisms/QualityControl/QCReportForm";
import QCReportDetail from "../../organisms/QualityControl/QCReportDetail";
import { getAllQCReports, deleteQCReport } from "../../api/qcReports";
import { Icon } from "@mui/material";
import { useCompany } from "../../contexts/CompanyContext";
import QCReportSheetModal from "../../organisms/FinishedGoods/QCReportSheetModal.tsx";

const QualityControlScreen = () => {
  const { selectedCompany } = useCompany();

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 80,
      type: "number",
    },
    {
      field: "workOrder",
      headerName: "Orden de Trabajo",
      width: 150,
    },
    {
      field: "finishedGoodName",
      headerName: "Producto Terminado",
      width: 200,
    },
    {
      field: "operationDate",
      headerName: "Fecha de Operación",
      width: 150,
    },
    {
      field: "quantity",
      headerName: "Cantidad",
      width: 100,
      type: "number",
    },
    {
      field: "inspectorName",
      headerName: "Inspector",
      width: 150,
    },
    {
      field: "shift",
      headerName: "Turno",
      width: 100,
    },
    {
      field: "observations",
      headerName: "Observaciones",
      width: 200,
    },
  ];

  const props = {
    fetchFunction: getAllQCReports,
    deleteFunction: deleteQCReport,
    data: { companyId: selectedCompany?.id },
    columns,
    actions: ["detail"],
    detailMenu: [
      {
        label: "Ver Detalles",
        header: "Detalles del Reporte de Control de Calidad",
        body: <QCReportSheetModal />,
      },
    ],
  };

  return (
    <DashboardLayout>
      <LGModalCrud props={props} />
    </DashboardLayout>
  );
};

export default QualityControlScreen; 